import React from 'react';
import { Col, Row } from 'react-bootstrap';

type DetailRowProps = {
  left: React.ReactNode;
  right: React.ReactNode;
};

export function DetailRow(props: DetailRowProps) {
  return (
    <Row className='mb-3'>
      <Col sm='12' md='5' className='text-md-right text-sm-left'>
        <b>{props.left}:</b>
      </Col>
      <Col sm='12' md='6' style={{ whiteSpace: 'pre-line' }}>
        {props.right}
      </Col>
    </Row>
  );
}
